export default "__VITE_ASSET__ChIfhOH8__"